import Vue from 'vue';
import format from 'date-fns/format';
import store from '@/store';
import { JsonStream } from '../../../../../../util/json-stream';
import { AdvancedSearchActions } from '../../../advanced-search/advanced-search.keys';
import { TimeSheetsListingActions } from '../time-sheets-listing/time-sheets-listing.keys';
import { BatchUpdateListingActions } from '../../../batch-update/batch-update-listing.keys';

export const timeSheetsListingService = {
  retrieveAssignments: function() {
    return Vue.axios.get('/assignments').then(response => response.data);
  },

  retrieveContractors: function() {
    return Vue.axios.get('/contractors').then(response => response.data);
  },

  retrieveTimeSheets: function(filters, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/time-sheets', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
          ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  retrieveStatusCounts: function() {
    return Vue.axios.get('/time-sheets/count-statuses').then(response => response.data);
  },

  retrieveFilteredSortedRecordCount: function(filters, sortOrder, searchParam) {
    return Vue.axios
      .get('/time-sheets/count-records', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
          ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
          ...sortOrder,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadTimeSheetsXlsx(filters, sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/time-sheets/xlsx`,
      method: 'GET',
      params: {
        ...filters.dateRangeFilters,
        ...filters.statusFilters,
        ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
        ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Time-Sheets-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async bulkUpdateTimeSheets(bulkAction, timeSheetRefs) {
    const jsonStream = new JsonStream();
    if (!(bulkAction.action === 'PDF')) {
      return Vue.axios
        .post('/time-sheets/bulk-update', {
          bulkAction,
          referenceNumbers: timeSheetRefs
        })
        .then(response => response.data);
    } else {
      await Vue.axios({
        method: 'post',
        url: '/time-sheets/bulk-pdf',
        data: {
          bulkAction,
          referenceNumbers: timeSheetRefs
        },
        responseType: 'text',
        onDownloadProgress: evt => {
          jsonStream.add(evt.target.response);
        }
      }).then(() => {
        jsonStream.setDone(true);
        store.dispatch(AdvancedSearchActions.SetBatchPdfLoading, false);
        store.dispatch(BatchUpdateListingActions.SetBatchPdfGenerated, false);
        store.dispatch(TimeSheetsListingActions.BatchTimeSheetslist, jsonStream.getJson());
      });
    }
  }
};
